import React from 'react';
import Icon from '../../../components/AppIcon';

const PlayerValueCard = ({ playerId, player, history, isSelected, onSelect }) => {
  const latestValue = history?.[history?.length - 1]?.value || 0;
  const previousValue = history?.length >= 2 ? history?.[history?.length - 2]?.value : latestValue;
  const valueChange = latestValue - previousValue;
  const percentageChange = previousValue > 0 ? ((valueChange / previousValue) * 100)?.toFixed(1) : 0;
  const isPositive = valueChange >= 0;

  return (
    <div 
      className={`bg-card border rounded-lg p-4 hover:shadow-md transition-all cursor-pointer ${
        isSelected ? 'border-primary ring-2 ring-primary/20' : 'border-border'
      }`}
      onClick={() => onSelect(playerId)}
    >
      {/* Selection Indicator */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          {isSelected && (
            <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center">
              <Icon name="Check" size={14} className="text-white" />
            </div>
          )}
        </div>
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
          isPositive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
        }`}>
          {isPositive ? '+' : ''}{percentageChange}%
        </div>
      </div>

      {/* Player Info */}
      <div className="flex items-start gap-3 mb-4">
        {player?.profilePhoto ? (
          <img 
            src={player?.profilePhoto} 
            alt={player?.fullName || 'Player'}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="User" size={20} className="text-primary" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-foreground truncate">
            {player?.knownAs || player?.fullName || 'Unknown Player'}
          </h4>
          <p className="text-xs text-muted-foreground">{player?.primaryPosition || 'N/A'}</p>
          <p className="text-xs text-muted-foreground truncate">{player?.currentClub || 'Free Agent'}</p>
        </div>
      </div>

      {/* Value Info */}
      <div className="space-y-2">
        <div>
          <span className="text-xs text-muted-foreground">Current Market Value</span>
          <p className="text-xl font-bold text-foreground">€{(latestValue / 1000000)?.toFixed(1)}M</p>
        </div>

        <div className="flex items-center gap-2">
          <Icon 
            name={isPositive ? 'ArrowUp' : 'ArrowDown'} 
            size={14} 
            className={isPositive ? 'text-success' : 'text-error'}
          />
          <span className={`text-sm font-medium ${
            isPositive ? 'text-success' : 'text-error'
          }`}>
            €{(Math.abs(valueChange) / 1000000)?.toFixed(2)}M
          </span>
        </div>

        <div className="pt-2 border-t border-border">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Valuations</span>
            <span className="font-medium text-foreground">{history?.length} data points</span>
          </div>
        </div>
      </div>

      {/* Selection Hint */}
      {!isSelected && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            Click to add to comparison
          </p>
        </div>
      )}
    </div>
  );
};

export default PlayerValueCard;